const contentHeaderCommon = `<h3>Header</h3>

[img]

To start working with the system, the user needs to add information about the customer:

1. Using the Edit button from any tab of the system you can return to editing the guest information at any time;


<div>
  When I click on Edit, it doesn’t allow me to edit existing information.
  I also can’t scroll to the bottom of the screen to update on my browser.  Molly experienced same issue, Kim did not.  We zoomed the brower to 80% and then it worked.  Should be able to do at 100%.
  How do I remove the name to go to a new name or add a name?
  We think we should add a clear button to remove existing customer.
  You can’t edit an existing customer based on what I was trying to do.
  When I click on an existing customer it should pull up all info so I can review and update as needed.
  Header dates should carry over to all categories in left section.  But still be able to change them.
  Make arrival and departure date so that they can type in dates without having to use calendar as well.
  In the arrival and departure dates can we also put the day of the week.
  Simple button.  What is that?  Can we move it up a tad so its not on line. Maybe we change it to “Validate” with on and off button.
  On the left side, besides dashboard, lets leave the structure the same as previous pos meaning shows would show up right after dashboard, followed by attractions…etc
</div>

<div>
  2. Clicking on this field will open a form for filling in the guest information, in which the user can:
  3. Select a guest from the list if the guest is in the database;
  4. Add information about the guest, if it is the first time he/she visits the facility;
  5. Choose the start and end dates of the visit;
  6. Fill in information about the number of guests, if the guest is with children, the user can fill in information about the age of each child in the corresponding field;
  7. Add another group of visitors;
  8. Remove the group of visitors;
  9. Add information about the visitors later or make changes;
</div>


<h3>Cart</h3>
[img]
<div>
  The customer can save the order in the cart using the Save Itinerary button.

  1. All saved Attractions/Dining/Shows/Hotels Room can be found in Header;
  2. The customer can view the list of chosen items;
  3. Clear a cart, edit and view the details of the order;
  4. Go to pay;
  5. After the user presses Buy Now, a timer will start for 15 minutes. The timer can be reset with the corresponding button.
</div>
  `
export default contentHeaderCommon
